import React, { useEffect, useRef, useState } from "react";

import { ReactComponent as ArrowDown } from "../assets/arrow-down.svg"; // Replace with your icon path

const Dropdown = ({ children, onSelect, disabled }) => {
  const [selectedOption, setSelectedOption] = useState("A - Z");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    setIsOpen(false); // Close the dropdown after selection
    if (onSelect) {
      onSelect(option); // Pass the selected option to the parent
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close the dropdown if clicked outside
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        disabled={disabled}
        className="flex w-full items-center justify-between space-x-3 rounded-xl border bg-[#ffffff] px-4 py-2 disabled:bg-gray-100 dark:border-dark-surface dark:bg-[#384049] dark:disabled:bg-[#303030]"
        onClick={toggleDropdown}
      >
        <span className={`font-semibold ${disabled ? "text-white" : ""} `}>{selectedOption}</span>
        <ArrowDown className={`h-2 w-2 ${disabled ? "text-white" : ""}`} />
      </button>
      {isOpen && (
        <div className="absolute left-0 z-10 mt-1 w-full rounded-xl bg-white p-1 shadow-md dark:bg-[#384049]">
          {React.Children.map(children, (child) => {
            return React.cloneElement(child, {
              onClick: () => handleOptionChange(child.props.children),
            });
          })}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
